import { DataService } from "./DataService";

export const DataBannerOne = [
  {
    id: 1,
    cl_bg_image: "bg_image-1",
    subTitle: "",
    title: "Bienvenue à SETELEC SAS",
    desc: "Nous apportons aux sociétés des solutions en ingénierie, travaux neufs, rénovation et maintenance.",
    link: "a_propos",
  },
  {
    id: 2,
    cl_bg_image: "bg_image-2",
    subTitle: `DEPARTEMENT ${DataService?.item1.title}`,
    title: "DEPARTEMENT ENERGIE",
    title: "Intégrité & Fiabilité",
    desc: " Ce département étudie et réalise les projets d’énergie couvrant la production, le transport, la distribution de l’énergie électrique et également la construction de centrales solaires photovoltaïques, Groupes électrogènes et hybrides... ",
    link: `detail_departement_${DataService?.item1.id}`,
  },
  {
    id: 3,
    cl_bg_image: "bg_image-3",
    subTitle: `DEPARTEMENT ${DataService?.item2.title}`,
    title: "Qualité & Securité",
    desc: "Le département Industrie gère les projets d’électricité, d’automatisme industriel, d’instrumentation, de Machines électriques et de constructions industrielles",
    link: `detail_departement_${DataService?.item2.id}`,
  },
  {
    id: 4,
    cl_bg_image: "bg_image-4",
    subTitle: `DEPARTEMENT ${DataService?.item3.title}`,
    title: "Solutions pour le Bâtiment",
    desc: "Le département Building Technologies s’oriente vers les solutions énergétiques pour le Bâtiment. Il touche les activités suivantes : Installation électrique courant fort, courant faible, Froid & Climatisation, Plomberie, Domotique, Maintenance...",
    link: `detail_departement_${DataService?.item3.id}`,
  },
  {
    id: 5,
    cl_bg_image: "bg_image-5",
    subTitle: `DEPARTEMENT ${DataService?.item4.title}`,
    title: "Matériels & Equipements Spécifiques",
    desc: "Le Département distribution de matériels industriels importe et fait la vente de matériels industriels et équipements spécifiques : disjoncteurs, compresseurs, onduleurs, régulateurs, lampadaires solaires, etc.",
    link: `detail_departement_${DataService?.item4.id}`,
  },
];
